import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { FaEnvelope, FaLock, FaSignInAlt, FaFire, FaEye, FaEyeSlash, FaArrowRight, FaHeart, FaCheck } from 'react-icons/fa';
import './auth.css';
import logo from '../../logo/logo.svg';
const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const { login } = useAuth();
  const navigate = useNavigate();

  // Background slides (mêmes images que Register)
  const slides = [  
    'https://murima.julesferry-ga.com/uploads/92233485_054_24b5.jpg',
    'https://murima.julesferry-ga.com/uploads/13331005_034_260d.jpg',
    'https://murima.julesferry-ga.com/uploads/30599539_057_93d6.jpg',
    'https://murima.julesferry-ga.com/uploads/86489020_027_fd46.jpg'
  ];

  // Captions pour chaque slide
  const captions = [
    'Retrouvez l\'amour',
    'Rencontres exotiques',
    'Moments magiques',
    'Vivez l\'aventure'
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const validateForm = () => {
    const newErrors = {};
    
    if (!email) {
      newErrors.email = "L'email est requis";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = "Format d'email invalide";
    }
    
    if (!password) {
      newErrors.password = "Le mot de passe est requis";
    } else if (password.length < 3) {
      newErrors.password = "Mot de passe trop court";
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) return;
    
    setLoading(true);
    setErrors({});
    
    try {
      const result = await login(email, password);
      
      if (result?.success && result?.user) {
        localStorage.setItem('userId', result.user.id);
        localStorage.setItem('user', JSON.stringify(result.user));
        navigate('/dashboard');
      } else {
        setErrors({ general: result?.error || 'Email ou mot de passe incorrect' });
      }
    } catch (error) {
      console.error('Login error:', error);
      setErrors({ general: 'Erreur de connexion au serveur' });
    } finally {
      setLoading(false);
    }
  };

  const handleGuestLogin = () => {
    setEmail('sophie@email.com');
    setPassword('password123');
    setTimeout(() => {
      handleSubmit(new Event('submit'));
    }, 100);
  };

  const inputStyle = {
    width: '100%',
    padding: '14px 18px 14px 48px',
    background: '#2a2a3a',
    border: '2px solid #ff4b6e',
    borderRadius: '30px',
    color: 'white',
    fontSize: '0.95rem',
    outline: 'none',
    transition: 'all 0.3s'
  };

  return (
    <div style={{ position: 'relative', width: '100%', height: '100vh', overflow: 'hidden' }}>
      {/* Background Slides */}
      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 0 }}>
        {slides.map((slide, index) => (
          <div
            key={index}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundImage: `url(${slide})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              opacity: currentSlide === index ? 1 : 0,
              transition: 'opacity 1.5s ease-in-out',
              transform: 'scale(1.05)',
              animation: currentSlide === index ? 'zoomIn 20s ease infinite alternate' : 'none'
            }}
          />
        ))}
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0.3) 100%)',
          zIndex: 1
        }} />
        <div style={{
          position: 'absolute',
          bottom: '40px',
          left: 0,
          right: 0,
          textAlign: 'center',
          color: 'white',
          fontSize: '1rem',
          fontWeight: '300',
          letterSpacing: '2px',
          textTransform: 'uppercase',
          zIndex: 2,
          textShadow: '0 2px 10px rgba(0, 0, 0, 0.5)',
          animation: 'fadeInUp 1s ease'
        }}>
          <p>{captions[currentSlide]}</p>
        </div>
      </div>

      {/* Main Content */}
      <div style={{ position: 'relative', zIndex: 10, display: 'flex', width: '100%', height: '100%' }}>
        {/* Logo et Branding - Gauche (disparaît sur mobile) */}
        <div className="login-brand-left" style={{ 
  flex: 1, 
  display: 'flex', 
  alignItems: 'center', 
  justifyContent: 'center', 
  background: 'linear-gradient(135deg, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.5) 100%)',
  backdropFilter: 'blur(10px)',
  height: '100%',
  position: 'relative',
  overflow: 'hidden'
}}>
  {/* Effet de particules en arrière-plan */}
  <div style={{
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'radial-gradient(circle at 30% 40%, rgba(255,75,110,0.1) 0%, transparent 70%)',
    pointerEvents: 'none'
  }} />
  
  <div style={{ 
    textAlign: 'center', 
    padding: '40px',
    animation: 'fadeInUp 0.8s ease',
    position: 'relative',
    zIndex: 2
  }}>
    {/* Logo avec effet de lueur */}
    <div style={{
      position: 'relative',
      display: 'inline-block',
      marginBottom: '30px'
    }}>
      <img 
        src={logo} 
        alt="MURIMA" 
        style={{ 
          width: '320px',
          filter: 'drop-shadow(0 0 20px rgba(255,75,110,0.4))',
          transition: 'all 0.3s ease'
        }} 
      />
      <div style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '120%',
        height: '120%',
        background: 'radial-gradient(circle, rgba(255,75,110,0.2) 0%, transparent 70%)',
        borderRadius: '50%',
        zIndex: -1,
        animation: 'pulse 2s ease infinite'
      }} />
    </div>
    
    {/* Titre avec dégradé */}
    <h2 style={{ 
      fontSize: '2rem', 
      fontWeight: '600',
      background: 'linear-gradient(135deg, #fff, #ff8a5c)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      marginBottom: '15px',
      letterSpacing: '-0.5px'
    }}>
      Plateforme de rencontres sensuelles
    </h2>
    
    {/* Ligne décorative */}
    <div style={{
      width: '80px',
      height: '3px',
      background: 'linear-gradient(90deg, #ff4b6e, #ff8a5c)',
      margin: '20px auto',
      borderRadius: '3px'
    }} />
    
    {/* Avantages avec icônes animées */}
    <div style={{ 
      marginTop: '50px', 
      display: 'flex', 
      flexDirection: 'column', 
      gap: '20px',
      background: 'rgba(255,255,255,0.03)',
      padding: '25px 35px',
      borderRadius: '30px',
      backdropFilter: 'blur(5px)',
      border: '1px solid rgba(255,75,110,0.2)'
    }}>
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: '12px', 
        color: 'rgba(255,255,255,0.9)',
        fontSize: '1.1rem',
        fontWeight: '500',
        transition: 'transform 0.3s ease',
        cursor: 'default'
      }}>
        <div style={{
          width: '32px',
          height: '32px',
          background: 'linear-gradient(135deg, #ff4b6e, #ff8a5c)',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 0 15px rgba(255,75,110,0.4)'
        }}>
          <FaCheck style={{ color: 'white', fontSize: '0.9rem' }} />
        </div>
        <span>Profils vérifiés</span>
      </div>
      
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: '12px', 
        color: 'rgba(255,255,255,0.9)',
        fontSize: '1.1rem',
        fontWeight: '500',
        transition: 'transform 0.3s ease',
        cursor: 'default'
      }}>
        <div style={{
          width: '32px',
          height: '32px',
          background: 'linear-gradient(135deg, #ff4b6e, #ff8a5c)',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 0 15px rgba(255,75,110,0.4)'
        }}>
          <FaCheck style={{ color: 'white', fontSize: '0.9rem' }} />
        </div>
        <span>Rencontres authentiques</span>
      </div>
      
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: '12px', 
        color: 'rgba(255,255,255,0.9)',
        fontSize: '1.1rem',
        fontWeight: '500',
        transition: 'transform 0.3s ease',
        cursor: 'default'
      }}>
        <div style={{
          width: '32px',
          height: '32px',
          background: 'linear-gradient(135deg, #ff4b6e, #ff8a5c)',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 0 15px rgba(255,75,110,0.4)'
        }}>
          <FaCheck style={{ color: 'white', fontSize: '0.9rem' }} />
        </div>
        <span>Sécurité garantie</span>
      </div>
    </div>
    
    {/* Petit texte en bas */}
    <p style={{
      marginTop: '30px',
      color: 'rgba(255,255,255,0.4)',
      fontSize: '0.75rem',
      letterSpacing: '0.5px'
    }}>
      Rejoignez des milliers de célibataires
    </p>
  </div>

  <style>{`
    @keyframes fadeInUp {
      from {
        opacity: 0;
        transform: translateY(30px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
    
    @keyframes pulse {
      0%, 100% {
        transform: translate(-50%, -50%) scale(1);
        opacity: 0.5;
      }
      50% {
        transform: translate(-50%, -50%) scale(1.2);
        opacity: 0.8;
      }
    }
    
    .login-brand-left div:hover .feature-item {
      transform: translateX(5px);
    }
  `}</style>
</div>

        {/* Formulaire - Droite */}
          <div style={{ 
  flex: 1, 
  display: 'flex', 
  alignItems: 'center', 
  justifyContent: 'center', 
  padding: '40px',
  background: 'rgba(0,0,0,0.4)',
  height: '100%',
  overflow: 'auto'
}}>
  <div style={{ 
    width: '100%', 
    maxWidth: '480px', 
    background: 'rgba(20,20,40,0.95)', 
    borderRadius: '32px', 
    padding: '25px 35px',
    boxShadow: '0 20px 40px rgba(0,0,0,0.5)',
    border: '1px solid rgba(255,75,110,0.3)'
  }}>
    {/* Logo mobile - centré */}
    <div style={{ 
      textAlign: 'center', 
      marginBottom: '0px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    }}>
      <img className="mobile-logo"
        src={logo} 
        alt="MURIMA" 
        style={{ 
          width: '280px',
          maxWidth: '80%',
          filter: 'drop-shadow(0 0 20px rgba(255,75,110,0.4))',
          transition: 'all 0.3s ease',
           display: 'none'
        }} 
      />
    </div>

    {/* Titre Bienvenue - centré */}
    <div style={{ textAlign: 'center', marginBottom: '35px' }}>
      <h2 style={{ 
        fontSize: '1.8rem', 
        fontWeight: '600', 
        color: 'white', 
        marginBottom: '8px',
        background: 'linear-gradient(135deg, #fff, #ff8a5c)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        display: 'inline-block'
      }}>
        Bienvenue
      </h2>
      <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.9rem', marginTop: '8px' }}>
        Connectez-vous à votre compte
      </p>
    </div>

    {/* Error Message */}
    {errors.general && (
      <div style={{
        background: 'rgba(255,75,110,0.15)',
        border: '1px solid rgba(255,75,110,0.3)',
        borderRadius: '16px',
        padding: '12px 16px',
        marginBottom: '24px',
        color: '#ff4b6e',
        fontSize: '0.85rem',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
      }}>
        <span>⚠️</span> {errors.general}
      </div>
    )}

    <form onSubmit={handleSubmit}>
      <div style={{ marginBottom: '20px' }}>
        <label style={{ 
          display: 'block', 
          color: 'rgba(255,255,255,0.7)', 
          fontSize: '0.8rem', 
          marginBottom: '8px',
          marginLeft: '4px',
          fontWeight: '500'
        }}>
          <FaEnvelope style={{ marginRight: '6px', color: '#ff4b6e' }} />
          Email
        </label>
        <div style={{ position: 'relative' }}>
          <FaEnvelope style={{ position: 'absolute', left: '18px', top: '50%', transform: 'translateY(-50%)', color: '#ff4b6e', zIndex: 2 }} />
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="votre@email.com"
            style={inputStyle}
            disabled={loading}
          />
        </div>
        {errors.email && <span style={{ color: '#ff4b6e', fontSize: '0.7rem', marginLeft: '18px', display: 'block', marginTop: '5px' }}>{errors.email}</span>}
      </div>

      <div style={{ marginBottom: '20px' }}>
        <label style={{ 
          display: 'block', 
          color: 'rgba(255,255,255,0.7)', 
          fontSize: '0.8rem', 
          marginBottom: '8px',
          marginLeft: '4px',
          fontWeight: '500'
        }}>
          <FaLock style={{ marginRight: '6px', color: '#ff4b6e' }} />
          Mot de passe
        </label>
        <div style={{ position: 'relative' }}>
          <FaLock style={{ position: 'absolute', left: '18px', top: '50%', transform: 'translateY(-50%)', color: '#ff4b6e', zIndex: 2 }} />
          <input
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            style={inputStyle}
            disabled={loading}
          />
          <button
            type="button"
            onClick={() => setShowPassword(!showPassword)}
            style={{ position: 'absolute', right: '18px', top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', color: 'rgba(255,255,255,0.6)', cursor: 'pointer' }}
          >
            {showPassword ? <FaEyeSlash /> : <FaEye />}
          </button>
        </div>
        {errors.password && <span style={{ color: '#ff4b6e', fontSize: '0.7rem', marginLeft: '18px', display: 'block', marginTop: '5px' }}>{errors.password}</span>}
      </div>

      <button 
        type="submit" 
        disabled={loading}
        style={{ 
          width: '100%',
          padding: '14px',
          background: 'linear-gradient(135deg, #ff4b6e, #ff8a5c)',
          border: 'none',
          borderRadius: '30px',
          color: 'white',
          fontSize: '0.95rem',
          fontWeight: '600',
          cursor: loading ? 'not-allowed' : 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '10px',
          transition: 'all 0.3s',
          opacity: loading ? 0.6 : 1,
          marginTop: '10px',
          boxShadow: '0 5px 15px rgba(255,75,110,0.3)'
        }}
      >
        {loading ? (
          <div style={{ width: '20px', height: '20px', border: '2px solid rgba(255,255,255,0.3)', borderTopColor: 'white', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
        ) : (
          <>
            <FaSignInAlt /> Se connecter
          </>
        )}
      </button>
    </form>

    {/* Footer */}
    <div style={{ textAlign: 'center', marginTop: '25px', paddingTop: '20px', borderTop: '1px solid rgba(255,255,255,0.1)', color: 'rgba(255,255,255,0.6)', fontSize: '0.85rem' }}>
      <button 
        onClick={handleGuestLogin}
        disabled={loading}
        style={{
          background: 'rgba(255,255,255,0.05)',
          border: '1px solid rgba(255,255,255,0.1)',
          borderRadius: '30px',
          color: 'rgba(255,255,255,0.7)',
          padding: '10px 20px',
          fontSize: '0.85rem',
          fontWeight: '500',
          cursor: 'pointer',
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          transition: 'all 0.3s',
          marginBottom: '15px'
        }}
      >
        <FaHeart /> Mode invité
      </button>
      
      <p>
        Pas encore de compte ? <Link to="/register" style={{ color: '#ff4b6e', textDecoration: 'none', fontWeight: '500' }}>S'inscrire</Link>
      </p>
    </div>
  </div>
</div>
      </div>

      <style>{`
        @keyframes zoomIn {
          from { transform: scale(1); }
          to { transform: scale(1.1); }
        }
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes spin {
          to { transform: rotate(360deg); }
        }

        /* Responsive - Masquer la section gauche sur mobile */
        @media (max-width: 992px) {
          .login-brand-left {
            display: none !important;
          }
          .bienvenue{
          display: none !important;
          }
          .mobile-logo {
            display: block !important;
          }
        }
      `}</style>
    </div>
  );
};

export default Login;